import { $fromDomEvent } from '@hypatia/streams/generators/from-dom-event'
import '@hypatia/streams/index'
import identity from 'lodash/identity'
import { isEqualShallow } from '../comparators/is-equal-shallow'

export default $fromDomEvent(window, 'resize')
    .startWith(undefined)
    .map(() => ({
        width: window.innerWidth,
        height: window.innerHeight,
    }))
    .distinctUntilChanged(identity, isEqualShallow)
    .deliverLast()
